module.exports = __webpack_public_path__ + "media/images/icons/camera-fill-25569be57b22ffe1108ba5a6ebfc71a0.svg";